import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2191a5ca")

_pushScopeId("data-v-2191a5ca")
const _hoisted_1 = {
  key: 1,
  class: "checkbox-icon cp-icon-checkmark-squarebox"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["inline-flex items-center form-checkbox cursor-pointer", [_ctx.disabled ? 'checkbox-disable' : '']],
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCheck && _ctx.toggleCheck(...args))),
    tabindex: "0"
  }, [
    (_ctx.isSelected)
      ? (_openBlock(), _createBlock("span", {
          key: 0,
          class: ["checkbox-icon cp-icon-checkmark-square checked", [_ctx.disabled ? 'checkbox-disable' : `${_ctx.color}`]]
        }, null, 2))
      : (_openBlock(), _createBlock("span", _hoisted_1)),
    (!!_ctx.label)
      ? (_openBlock(), _createBlock("span", {
          key: 2,
          class: "ml-2",
          style: {
        fontWeight: _ctx.labelBold ? 'bold' : 'normal',
        fontSize: _ctx.fontSize + 'px',
      }
        }, _toDisplayString(_ctx.label), 5))
      : _createCommentVNode("", true)
  ], 2))
})